export class SearchRequestBaseModel {
    filters: IFilterModel[] = [];
    sortings: ISortModel[] = [];
    pageNumber: number = 1;
    pageSize: number = 10;
    merchantId?: string = "";
    individualId?: number = 0;
    cardId?: number = 0;
    from?: string;
    to?: string;
}

export interface IFilterModel {
    columnName: string;
    operator: string;
    value: string | number;
}

export interface ISortModel {
    sortOrder: number;
    sortBy: string;
}

export enum SortOrderType {
    Ascending = 1,
    Descending = -1,
}
